import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-ink-textLow font-serif italic text-xl animate-fade-in-slow">
                a moment of quiet…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
